module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-06.9b36d641.svg";